import { Switch, Tooltip } from 'antd';
import type { FC } from 'react';

export interface AuthA11yToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  helpText?: string;
  /** Top placement keeps the toggle visible above the reCAPTCHA badge on phones. */
  placement?: 'header' | 'footer';
}

export const AuthA11yToggle: FC<AuthA11yToggleProps> = ({
  checked,
  onChange,
  label = 'Accessibility mode',
  helpText = 'Shows field labels, higher contrast, and clearer focus and links',
  placement = 'footer',
}) => (
  <div
    className={`login-a11y-toggle${
      placement === 'header' ? ' login-a11y-toggle--header' : ''
    }`}
  >
    <Tooltip title={helpText}>
      <Switch
        size="small"
        checked={checked}
        onChange={onChange}
        aria-label={label}
      />
    </Tooltip>
    <span className="login-a11y-toggle__label">{label}</span>
  </div>
);
